import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import LoginView from "../auth/login/index";
// import UserRegisterView from '../auth/register/index'
// import OtpVerificationView from "../auth/otpVerification/index";
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";

import MeetingFormView from "../meetingForm/index"

import MeetingSummeryView from "../meetingSummery/index"

import Protected_route from "./protected_route";


const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to={routes.login} />,
    route: Route,
  },

  {
    path: routes.meetingFormView,
    element: <Protected_route Component={MeetingFormView} />,
    route: Route,
  },,

  {
    path: routes.MeetingSummeryView,
    element: <Protected_route Component={MeetingSummeryView} />,
    route: Route,
  },

  // {
  //   path: routes.userApprovalView,
  //   element: <Protected_route Component={UserApprovalView} />,
  //   route: Route,
  // },
  // {
  //   path: routes.surveyorDetailsView,
  //   element: <Protected_route Component={SurveyorDetailsView} />,
  //   route: Route,
  // },
  // {
  //   path: routes.consumerAllotmentView,
  //   element: <Protected_route Component={ConsumerAllotmentView} />,
  //   route: Route,
  // },

  
];

export const authRoutes = [

  {
    path: routes.login,
    element: <LoginView />,
    route: Route,
  },

  // {
  //   path: routes.userRegister,
  //   element: <UserRegisterView />,
  //   route: Route,
  // },

  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },

  {
    path: "*",
    element: <Error404 />,
    route: Route,
  } ,

];
